import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ZinuzhComponent } from './zinuzh/zinuzh.component';
import { HayzinvorComponent } from './hayzinvor/hayzinvor.component';
import { AsparComponent } from './aspar/aspar.component';
import { LrahosComponent } from './lrahos/lrahos.component';
import { ArchiveComponent } from './archive/archive.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactusComponent } from './contactus/contactus.component';
import { HayzinvorDetalesComponent } from './hayzinvor-detales/hayzinvor-detales.component';
import { ZinuzhArchiveComponent } from './zinuzh-archive/zinuzh-archive.component';
import { HayzinvorArchiveComponent } from './hayzinvor-archive/hayzinvor-archive.component';
import { AsparArchiveComponent } from './aspar-archive/aspar-archive.component';
import { TesanyuterComponent } from './tesanyuter/tesanyuter.component';
import { PhotosComponent } from './photos/photos.component';
import { SongsComponent } from './songs/songs.component';
import { AlbomComponent } from './albom/albom.component';
import { SongItemComponent } from './song-item/song-item.component';
import { NewsDetalesComponent } from './news-detales/news-detales.component';
import { ZinvorArchiveNewsComponent } from './zinvor-archive-news/zinvor-archive-news.component';
import { ZinvorArchiveItemComponent } from './zinvor-archive-item/zinvor-archive-item.component';
import { RoutingComponentComponent } from './routing-component/routing-component.component';
import { TranslateServiceService } from './translate-service.service';
import { VideosCategoryComponent } from './videos-category/videos-category.component';
import { SongCategoryComponent } from './song-category/song-category.component';
import { SearchResoultComponent } from './search-resoult/search-resoult.component';
import { ZinujXoragirComponent } from './zinuj-xoragir/zinuj-xoragir.component';
import { HayzinvorXoragirComponent } from './hayzinvor-xoragir/hayzinvor-xoragir.component';
import { AsparKhoragirComponent } from './aspar-khoragir/aspar-khoragir.component';
import { WorkersComponent } from './workers/workers.component';
import { ZoratesaknerComponent } from './zoratesakner/zoratesakner.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ArchiveLiveComponent } from './archive-live/archive-live.component';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';

const routes: Routes = [
  {path: ':lang' , component: RoutingComponentComponent , children: [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'home/news_detales/:id', component: NewsDetalesComponent },
    { path: 'news_detales/:id', component: NewsDetalesComponent },
    { path: 'home/zinuzh', component: ZinuzhComponent },
    { path: 'zinuzh', component: ZinuzhComponent },
    { path: 'zinuzh/zinuzh-khoragir/:id', component: ZinujXoragirComponent },
    { path: 'searchResult' , component: SearchResoultComponent},
    { path: 'searchResult/lrahos_ts' , component: SearchResoultComponent},
    { path: 'searchResult/music' , component: SearchResoultComponent},
    { path: 'searchResult/video' , component: SearchResoultComponent},
    { path: 'searchResult/hay_zinvor_ts' , component: SearchResoultComponent},
    { path: 'searchResult/zinuj_ts' , component: SearchResoultComponent},
    { path: 'searchResult/zinuj_galery_ts' , component: SearchResoultComponent},
    { path: 'hayzinvor', component: HayzinvorComponent },
    { path: 'home/hayzinvor', component: HayzinvorComponent },
    { path: 'hayzinvor/hayzinvor-khoragir/:id', component: HayzinvorXoragirComponent },
    { path: 'home/hayzinvor-khoragir/:id', component: HayzinvorXoragirComponent },
    { path: 'home/hayzinvor/hayzinvor-khoragir/:id', component: HayzinvorXoragirComponent },
    { path: 'home/zoratesakner-khoragir', component: ZoratesaknerComponent },
    { path: 'zoratesakner-khoragir', component: ZoratesaknerComponent },
    { path: 'aspar/zoratesakner-khoragir', component: ZoratesaknerComponent },
    { path: 'hayzinvor/zoratesakner-khoragir', component: ZoratesaknerComponent },
    { path: 'zinuzh/zoratesakner-khoragir', component: ZoratesaknerComponent },
    { path: 'hayzinvor-khoragir/:id', component: HayzinvorXoragirComponent },
    { path: 'aspar/aspar-khoragir/:id', component: AsparKhoragirComponent },
    { path: 'home/aspar/aspar-khoragir/:id', component: AsparKhoragirComponent },
    { path: 'aspar', component: AsparComponent },
    { path: 'home/aspar', component: AsparComponent },
    { path: 'aboutUs/workers', component: WorkersComponent },
    { path: 'hayzinvor/hayzinvor-khoragir/:id/hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'archive/hayzinvor_archive/:id/hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'searchResult/hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'hayzinvor/hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'home/hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'hayzinvor/hayzinvor_detales/:id/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/hay_zinvor_ts/hayzinvor_detales/:id', component: HayzinvorDetalesComponent },
    { path: 'lrahos/news_detales/:id', component: NewsDetalesComponent},
    { path: 'home/hayzinvor_detales/:id/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/lrahos_ts/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/music/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/video/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/hay_zinvor_ts/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/zinuj_ts/news_detales/:id', component: NewsDetalesComponent},
    { path: 'searchResult/zinuj_galery_ts/news_detales/:id', component: NewsDetalesComponent},
    { path: 'lrahos', component: LrahosComponent },
    { path: 'home/lrahos', component: LrahosComponent },
    { path: 'home/lrahos/:id', component: LrahosComponent },
    { path: 'home/lrahos/news_detales/:id' , component: NewsDetalesComponent },
    { path: 'zinuzh_archive/:id', component: ZinuzhArchiveComponent },
    { path: 'hayzinvor_archive/:id' , component: HayzinvorArchiveComponent},
    { path: 'aspar_archive/:id' , component: AsparArchiveComponent},
    { path: 'live_archive/:id' , component: ArchiveLiveComponent},
    { path: 'aboutUs', component: AboutusComponent },
    { path: 'home/aboutUs', component: AboutusComponent },
    { path: 'videos', component: TesanyuterComponent },
    { path: 'videos/category/:id', component: VideosCategoryComponent },
    { path: 'pictures', component: PhotosComponent   },
    { path: 'archive/hayzinvor_archive/:id/hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'hayzinvor_detales/:id', component: HayzinvorDetalesComponent},
    { path: 'pictures/albom/:id', component:  AlbomComponent  },
    { path: 'songs', component: SongsComponent },
    { path: 'songs/category/:id', component: SongCategoryComponent },
    { path: 'songs/category/:id/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/lrahos_ts/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/music/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/video/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/hay_zinvor_ts/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/zinuj_ts/song-lyrics/:id', component: SongItemComponent },
    { path: 'searchResult/zinuj_galery_ts/song-lyrics/:id', component: SongItemComponent },
    { path:'songs/song-lyrics/:id', component: SongItemComponent},
    { path: 'contactUs', component: ContactusComponent },
    { path: 'notFound', component: NotFoundComponent },
    { path: '404', redirectTo: 'notFound', pathMatch:'full' },

    ] },
    { path: '' , redirectTo:  'home' , pathMatch: 'full' },



  ]


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    initialNavigation: 'enabled',
  })],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
  exports: [RouterModule],
})
export class AppRoutingModule {

}
